// eslint-disable-next-line import/prefer-default-export
export const TestimonialsVideoContent = [
  {
    title: 'Online Betting Platform leveraging Blockchain Technology',
    location: 'Spain',
    destination: 'Director',
    videourl: '/assets/video/video1.mp4',
    videThumb: '/assets/images/testimonial/v1.jpg',
  },
  {
    title: 'Marketplace for trading files/tools',
    location: 'Denmark',
    destination: 'Owner & Founder',
    videourl: '/assets/video/client1.mp4',
    videThumb: '/assets/images/testimonial/client1.jpg',
  },
  {
    title: 'Blockchain Solution',
    location: 'USA',
    destination: 'CEO',
    videourl: '/assets/video/client3.mp4',
    videThumb: '/assets/images/testimonial/client3.jpg',
  },
  {
    title: 'Social Media App',
    location: 'Spain',
    destination: 'CTO',
    videourl: '/assets/video/video2.mp4',
    videThumb: '/assets/images/testimonial/v2.jpg',
  },
  {
    title: 'Loyalty Platform',
    location: 'Chile',
    destination: 'Executive Director',
    videourl: '/assets/video/client2.mp4',
    videThumb: '/assets/images/testimonial/client2.jpg',
  },
]
